import type { CSSProperties } from 'react';

import { FEEDBACK_STATUS_COLORS, FEEDBACK_STATUS_LABELS, type FeedbackStatus } from '../../interface/feedback';

const FeedbackStatusBadge = ({ status }: { status: FeedbackStatus }) => {
	const color = FEEDBACK_STATUS_COLORS[status] || 'var(--neutral-500)';
	return (
		<span
			className='feedback-status-badge'
			style={{ '--badge-color': color } as CSSProperties}
		>
			<span className='feedback-status-badge__dot' />
			{FEEDBACK_STATUS_LABELS[status] || status}
		</span>
	);
};

export default FeedbackStatusBadge;
